import Head from 'next/head';
import React from "react";

import Templates from 'Templates/components/Templates';
import HeaderUser from '../header_user';

function TemplatesComponent() {

    return <>
        <HeaderUser />
        <Head>
            <title>Templates</title>
            <link rel="stylesheet" href="/static/frontend/styles/templates.css" />
            <link rel="stylesheet" href="/static/frontend/sass/scssTemplates.scss" />
            <link rel="stylesheet" href="/static/frontend/styles/scssTemplates.css" />
        </Head>
        <div >
            <div id="app">
                <div className="TemplatesWrapper">
                <div className="title_block"><h2>Templates</h2></div>
                        <Templates />
                </div>
            </div>
        </div>
    </>;
}

export default TemplatesComponent;